import { Validators } from '@biteinc/common';
import { CountryCode, CountrySubdivision, Timezone, UserRight } from '@biteinc/enums';
import { AbstractModelSchema } from './abstract_model_schema.js';
export const siteSchema = {
    displayName: 'site',
    type: 'object',
    fields: {
        ...AbstractModelSchema.fields,
        name: {
            type: 'keyString',
            required: true,
            tabId: 'site-settings',
            writeRight: UserRight.CreateSitesAndChannels,
        },
        storeNumber: {
            type: 'keyString',
            displayName: 'Store Number',
            tabId: 'site-settings',
            writeRight: UserRight.CreateSitesAndChannels,
            validationRegex: Validators.siteStoreNumberRegexString,
            tooltip: {
                text: 'Allowed characters: uppercase letters, numbers, and dashes.',
            },
        },
        address: {
            displayName: 'Address',
            type: 'object',
            required: true,
            tabId: 'site-settings',
            writeRight: UserRight.CreateSitesAndChannels,
            // Only postalCode and countryCode are user-editable for now; the rest of the
            // address fields are hidden until we collect them.
            fields: {
                line1: {
                    displayName: 'Line 1',
                    type: 'keyString',
                    isHidden: true,
                    validationRegex: Validators.addressLineRegex,
                },
                line2: {
                    displayName: 'Line 2',
                    type: 'keyString',
                    isHidden: true,
                    validationRegex: Validators.addressLineRegex,
                },
                crossStreet: {
                    displayName: 'Cross Street',
                    type: 'keyString',
                    isHidden: true,
                    validationRegex: Validators.simpleStringRegexString({
                        allowCommas: true,
                        specialCharacters: `@&#,'()/`,
                        allowDiacritics: true,
                    }),
                },
                city: {
                    type: 'keyString',
                    isHidden: true,
                    validationRegex: Validators.addressLineRegex,
                },
                state: {
                    type: 'stringEnum',
                    enum: CountrySubdivision,
                    required: true,
                    conditions: [
                        {
                            field: 'countryCode',
                            values: [CountryCode.Canada, CountryCode.UnitedStates],
                        },
                    ],
                },
                postalCode: {
                    displayName: 'Postal Code',
                    type: 'keyString',
                    required: true,
                    validationRegex: Validators.postalCodeRegexString,
                },
                countryCode: {
                    displayName: 'Country',
                    type: 'stringEnum',
                    enum: CountryCode,
                    required: true,
                    ui: 'dropdown',
                },
            },
        },
        timezone: {
            displayName: 'Time zone',
            type: 'stringEnum',
            enum: Timezone,
            required: true,
            ui: 'dropdown',
            tabId: 'site-settings',
            writeRight: UserRight.CreateSitesAndChannels,
        },
        biteOnly: {
            type: 'bool',
            displayName: 'Bite-Only',
            tabId: 'site-settings',
            biteOnly: true,
        },
        orderThrottlingRules: {
            type: 'array',
            elementType: 'object',
            elementSubtype: 'OrderThrottlingRule',
            displayName: 'Order throttling rules',
            ui: 'accordion',
            uiSubtype: 'OrderThrottlingRule',
            tabId: 'order-throttling',
            writeRight: UserRight.ManageOrderThrottling,
        },
        orderThrottlingAsapOrdersShouldCount: {
            type: 'bool',
            defaultValue: true,
            displayName: 'ASAP orders should count',
            tabId: 'order-throttling',
            writeRight: UserRight.ManageOrderThrottling,
            conditions: [
                {
                    field: 'orderThrottlingRules',
                    exists: true,
                },
            ],
        },
        fulfillmentStations: {
            type: 'array',
            elementType: 'object',
            ui: 'accordion',
            uiSubtype: 'FulfillmentStations',
            tabId: 'site-settings',
            displayName: 'Fulfillment stations',
            tooltip: {
                text: 'Only applies to Fresh KDS.',
            },
            fields: {
                _id: {
                    type: 'mongoId',
                    isHidden: true,
                },
                name: {
                    type: 'shortString',
                    displayName: 'Name',
                    required: true,
                },
                isEnabled: {
                    type: 'bool',
                    displayName: 'Enabled',
                    defaultValue: true,
                },
            },
        },
    },
};
//# sourceMappingURL=site_schema.js.map